import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

// List users in the current BU that can be @mentioned in comments
export const listMentionableUsers = async (options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(
    `${BASE_URL}/auth/users/in-my-business-unit`,
    buId ? { headers: { "X-Business-Unit-Id": buId } } : {}
  );
  return response.data;
};

// Look up whether a user already exists in the platform by email
export const lookupUserByEmail = async (email) => {
  const response = await axios.get(`${BASE_URL}/auth/users/lookup`, {
    params: { email },
  });
  return response.data;
};

// Basic company / trial status for the authenticated user. Used right
// after login to detect an expired trial before sending the user into
// the portal.
export const getCompanyBasicStatus = async () => {
  const response = await axios.get(`${BASE_URL}/auth/company/basic`);
  return response.data;
};
